import type { Page } from "#gen/pages/v2/page_pb.js";
import { booleanValue, structValue } from "#lib/struct.js";

export interface FormLayout {
	stickySubmitButton: boolean;
}

export function formLayout(page: Page | undefined, id: string): FormLayout {
	const config = structValue(page?.config, id);
	return {
		stickySubmitButton: booleanValue(config, "stickySubmitButton") ?? true,
	};
}
